import { parseAsString, useQueryState } from 'nuqs'
import { useAppointmentDraftStore } from '../../../features/appointment/create'

function toDateKey(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function parseDateKey(key: string): Date | null {
  const [y, m, d] = key.split('-').map(Number)
  if (!y || !m || !d) return null
  const date = new Date(y, m - 1, d)
  return Number.isNaN(date.getTime()) ? null : date
}

function skipWeekend(date: Date, direction: 1 | -1): Date {
  const d = new Date(date)
  while (d.getDay() === 0 || d.getDay() === 6) {
    d.setDate(d.getDate() + direction)
  }
  return d
}

const deFormatter = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export function useTimelineDay() {
  const [dayKey, setDayKey] = useQueryState('day', parseAsString.withDefault(''))
  const draftDate = useAppointmentDraftStore((s) => s.draft?.plannedStart)

  const resolvedDate = (() => {
    if (dayKey) {
      const parsed = parseDateKey(dayKey)
      if (parsed) return skipWeekend(parsed, 1)
    }
    if (draftDate) {
      const parsed = new Date(draftDate)
      if (!Number.isNaN(parsed.getTime())) return skipWeekend(parsed, 1)
    }
    return skipWeekend(new Date(), 1)
  })()

  const dayIso = new Date(
    resolvedDate.getFullYear(),
    resolvedDate.getMonth(),
    resolvedDate.getDate(),
    0, 0, 0, 0,
  ).toISOString()

  const formattedLabel = deFormatter.format(resolvedDate)

  const goToPrevDay = () => {
    const prev = new Date(resolvedDate)
    prev.setDate(prev.getDate() - 1)
    setDayKey(toDateKey(skipWeekend(prev, -1)))
  }

  const goToNextDay = () => {
    const next = new Date(resolvedDate)
    next.setDate(next.getDate() + 1)
    setDayKey(toDateKey(skipWeekend(next, 1)))
  }

  return { dayIso, formattedLabel, goToPrevDay, goToNextDay }
}
